module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "c"
  }, [_c('img', {
    staticClass: "calibre2",
    attrs: {
      "alt": "“ARE YOU THE M. JACKSON THEN WHO HAD AN AVERAGE OF FIFTY ONE POINT NOUGHT THREE LAST YEAR?”",
      "src": "OEBPS/Images/Images0001.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "sigilnotintoc2",
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_vm._v("[Dedication]"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  TO"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  ALAN DURAND")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76907c66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0002.vue
// module id = 60
// module chunks = 0